// removed by extract-text-webpack-plugin
module.exports = {"plandocuments":"_1k7j7"};


//////////////////
// WEBPACK FOOTER
// ./src/views/PartnerPlans/components/Sidebar/Sidebar.scss
// module id = 728
// module chunks = 0